export default "__VITE_ASSET__B5Ef02LV__"